import { useAppModal } from "@/contexts/AppModal/useAppModal";
import { RowSelectedType } from "@/contexts/RowSelection/RowSelectionContext";
import {
  Button,
  ButtonSeverity,
  ButtonVariant,
  Checkbox,
  DeleteIcon,
  HorizontalFlex,
  MediumTextM,
  Modal,
  ModalSize,
  Space,
  VerticalFlex,
} from "@enxcs/dap-ui-stratos";
import { useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
export interface DeleteRecordingModalProps {
  selecteds: Map<string, RowSelectedType>;
  onConfirm(): void;
  isLoading: boolean;
}

export function DeleteRecordingModal({ selecteds, onConfirm, isLoading }: DeleteRecordingModalProps) {
  const [confirm, setConfirm] = useState(false);

  const { t } = useTranslation();

  const { onCloseModal } = useAppModal();

  const items = selecteds.size;

  const modalSize = 440 as ModalSize;

  const exports = useMemo(() => {
    let totalExports = 0;

    selecteds.forEach((value) => {
      totalExports += value.exports.size;
    });

    return totalExports;
  }, [selecteds]);

  return (
    <Modal
      size={modalSize}
      title={t("deleteRecording.modal.title")}
      closeTitle={t("buttons.close")}
      body={
        <VerticalFlex $gap={Space.V8} $justify="space-between" $align={"center"}>
          <HorizontalFlex $pad={Space.V8}>
            <MediumTextM>
              {exports ? (
                <Trans i18nKey="deleteRecording.modal.descriptionWithExports" values={{ items, exports }} />
              ) : (
                <Trans i18nKey="deleteRecording.modal.descriptionWithoutExports" values={{ items }} />
              )}
            </MediumTextM>
          </HorizontalFlex>

          <HorizontalFlex $pad={Space.V16}>
            <Checkbox
              label={<MediumTextM>{t("deleteRecording.modal.confirmation")}</MediumTextM>}
              title={t("deleteRecording.modal.confirmation")}
              value={confirm}
              onChange={() => setConfirm((prevState) => !prevState)}
            />
          </HorizontalFlex>
        </VerticalFlex>
      }
      footer={
        <HorizontalFlex $justify="flex-end" $gap={Space.V8}>
          <Button variant={ButtonVariant.SECONDARY} onClick={onCloseModal} label={t("buttons.cancel")} disabled={isLoading} />
          <Button
            variant={ButtonVariant.PRIMARY}
            severity={ButtonSeverity.DANGER}
            disabled={isLoading || !confirm}
            label={t("buttons.delete")}
            onClick={onConfirm}
            leftIcon={DeleteIcon}
          />
        </HorizontalFlex>
      }
      onClose={onCloseModal}
    />
  );
}
